import { CountryLanguageDetails } from '../../models/utils/country-language.interfaces';
import { mockCountryLanguageData } from '../utils/country-language.mocks';

/**
 * Fallback country-language data based on fallback/country-language.json.
 * Used when the HTTP request to fetch country-language data fails.
 */
export const COUNTRY_LANGUAGE_FALLBACK: CountryLanguageDetails =
  mockCountryLanguageData;
